import { jsx as _jsx } from "react/jsx-runtime";
import { createTheme, ThemeProvider, useMediaQuery, useTheme } from "@mui/material";
// eslint-disable-next-line no-duplicate-imports
import { createContext, useContext, useMemo, useState } from "react";
const ColorModeContext = createContext(undefined);
function ColorModeProvider({ children }) {
    const outerTheme = useTheme();
    let prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
    prefersDarkMode = false;
    const [colorMode, setColorMode] = useState(prefersDarkMode ? "dark" : "light");
    const lightTheme = useMemo(() => createTheme({
        atlasThemeName: "atlas",
        palette: Object.assign(Object.assign({}, outerTheme.palette), { mode: "light" }),
        tokens: outerTheme.tokens,
        presets: outerTheme.presets,
    }, outerTheme), [outerTheme]);
    const darkTheme = useMemo(() => createTheme({
        atlasThemeName: "atlas",
        palette: Object.assign(Object.assign({}, outerTheme.palette), { mode: "dark" }),
        tokens: outerTheme.tokens,
        presets: outerTheme.presets,
    }), [outerTheme]);
    const state = useMemo(() => ({ colorMode, setColorMode }), [colorMode]);
    return (_jsx(ThemeProvider, Object.assign({ theme: colorMode === "dark" ? darkTheme : lightTheme }, { children: _jsx(ColorModeContext.Provider, Object.assign({ value: state }, { children: children })) })));
}
function useColorMode() {
    const ctx = useContext(ColorModeContext);
    if (!ctx) {
        throw new Error("useColorMode must be used within a ColorModeProvider");
    }
    return ctx;
}
export { ColorModeProvider, useColorMode };
//# sourceMappingURL=ColorModeProvider.js.map